export const ASSIGN_ENTITIES_GET_ALL_SITES_LOADING =
  'ASSIGN_ENTITIES_GET_ALL_SITES_LOADING';
export const ASSIGN_ENTITIES_ALL_SITES_DATA = 'ASSIGN_ENTITIES_ALL_SITES_DATA';
export const ASSIGN_ENTITIES_GET_ALL_SITES_LOADING_ERROR =
  'ASSIGN_ENTITIES_GET_ALL_SITES_LOADING_ERROR';

//items by site
export const ASSIGN_ENTITIES_ITEMS_GRID_UPDATE =
  'ASSIGN_ENTITIES_ITEMS_GRID_UPDATE';

//items by site group id
export const RE_ORDER_ITEM_LIST = 'RE_ORDER_ITEM_LIST';
//site group
export const ASSIGN_ENTITIES_SITE_GROUP_LOADING =
  'ASSIGN_ENTITIES_SITE_GROUP_LOADING';
export const ASSIGN_ENTITIES_SITE_GROUP_DATA =
  'ASSIGN_ENTITIES_SITE_GROUP_DATA';
export const ASSIGN_ENTITIES_SITE_GROUP_LOADING_ERROR =
  'ASSIGN_ENTITIES_SITE_GROUP_LOADING_ERROR';

//items
export const ASSIGN_ENTITIES_GET_ITEMS_DATA = 'ASSIGN_ENTITIES_GET_ITEMS_DATA';
export const ASSIGN_ENTITIES_GET_ITEMS_LOADING_ERROR =
  'ASSIGN_ENTITIES_GET_ITEMS_LOADING_ERROR';
export const ASSIGN_ENTITIES_GET_ITEMS_LOADING =
  'ASSIGN_ENTITIES_GET_ITEMS_LOADING';

//reorder
export const RE_ORDER_SITES_LIST = 'RE_ORDER_SITES_LIST';
export const RE_ORDER_SITE_GROUPS = 'RE_ORDER_SITE_GROUPS';
export const RE_ORDER_SITES = 'RE_ORDER_SITES';

export const ASSIGN_ENTITIES_GET_USERS_LOADING =
  'ASSIGN_ENTITIES_GET_USERS_LOADING';
export const ASSIGN_ENTITIES_GET_USERS_DATA = 'ASSIGN_ENTITIES_GET_USERS_DATA';
export const ASSIGN_ENTITIES_GET_USERS_LOADING_ERROR =
  'ASSIGN_ENTITIES_GET_USERS_LOADING_ERROR';
export const ASSIGN_ENTITIES_CLEAR_USER_DATA =
  'ASSIGN_ENTITIES_CLEAR_USER_DATA';

export const SUBMITTING_ASSIGN_ENTITIES = 'SUBMITTING_ASSIGN_ENTITIES';
export const SUBMITTED_ASSIGN_ENTITIES = 'SUBMITTED_ASSIGN_ENTITIES';
export const SUBMITTING_ASSIGN_ENTITIES_ERROR =
  'SUBMITTING_ASSIGN_ENTITIES_ERROR';
export const CLEAR_SUBMIT_ERROR = 'CLEAR_SUBMIT_ERROR';

export const GET_STORAGE_LOCATION_LOADING_ERROR =
  'GET_STORAGE_LOCATION_LOADING_ERROR';
export const GET_STORAGE_LOCATION_LOADING = 'GET_STORAGE_LOCATION_LOADING';
export const CLEAR_STORAGE_LOCATION_LOADING_ERROR =
  'CLEAR_STORAGE_LOCATION_LOADING_ERROR';

export const SET_SELECTED_SITE_ORDER_PREFERENCE_ID =
  'SET_SELECTED_SITE_ORDER_PREFERENCE_ID';

export const SET_SITES_BY_ITEM_ID = 'SET_SITES_BY_ITEM_ID';
export const SET_ITEMS_BY_SITE_ID = 'SET_ITEMS_BY_SITE_ID';

export const SET_SITE_GROUPS_BY_ITEM_ID = 'SET_SITE_GROUPS_BY_ITEM_ID';
export const SET_ITEMS_BY_SITE_GROUP_ID = 'SET_ITEMS_BY_SITE_GROUP_ID';
export const SET_SITES_BY_USER_NAME = 'SET_SITES_BY_USER_NAME';
export const SET_SITE_GROUPS_BY_USER_NAME = 'SET_SITE_GROUPS_BY_USER_NAME';
export const SET_USERS_BY_SITE_GROUP_ID = 'SET_USERS_BY_SITE_GROUP_ID';
export const SET_USERS_BY_SITE_ID = 'SET_USERS_BY_SITE_ID';
export const RE_ORDER_USERS_LIST = 'RE_ORDER_USERS_LIST';

export const SET_STORAGE_LOCATION_ASSIGNED_DATA =
  'SET_STORAGE_LOCATION_ASSIGNED_DATA';



// WEBPACK FOOTER //
// ./src/pages/utilities/state/assignEntities/types.js